import { render, staticRenderFns } from "./BatchImportImg.vue?vue&type=template&id=2e0ada45&scoped=true"
import script from "./BatchImportImg.vue?vue&type=script&lang=js"
export * from "./BatchImportImg.vue?vue&type=script&lang=js"
import style0 from "./BatchImportImg.vue?vue&type=style&index=0&id=2e0ada45&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ada45",
  null
  
)

export default component.exports